'use client';

import Link from 'next/link';
import { ReactNode } from 'react';

// Simple Link component using Next.js built-in Link
// This avoids custom navigation logic that caused reload loops
export function SmoothLink({
  href,
  children,
  className = '',
  onClick
}: {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <Link href={href} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
